import { keymap } from "prosemirror-keymap";
import { defaultDeleteFilter, redo, undo, yCursorPlugin, ySyncPlugin, ySyncPluginKey, yUndoPlugin, } from "y-prosemirror";
import { Extension } from "../../core/extension";
import { UndoManager } from "yjs";
export class CollabExtension extends Extension {
    constructor(options) {
        super();
        this.options = options;
    }
    addPlugins(schema, plugins) {
        var _a;
        const provider = this.options.getProvider();
        const ydoc = provider.doc;
        const type = ydoc.getXmlFragment("prosemirror");
        const protectedNodes = (_a = this.options.protectedNodes) !== null && _a !== void 0 ? _a : new Set(["paragraph"]);
        const collabPlugins = [
            ySyncPlugin(type),
            yCursorPlugin(provider.awareness),
        ];
        if (!this.options.disableUndo) {
            const undoManager = new UndoManager(type, {
                trackedOrigins: new Set([ySyncPluginKey]),
                deleteFilter: (item) => defaultDeleteFilter(item, protectedNodes),
            });
            collabPlugins.push(yUndoPlugin({
                undoManager,
            }), keymap({
                "Mod-z": undo,
                "Mod-y": redo,
                "Mod-Shift-z": redo,
            }));
        }
        return plugins.concat(collabPlugins);
    }
}
